import { useState, useEffect } from "react";
import { PhoneIcon } from "@heroicons/react/24/outline";
import { useContactForm } from "./ContactContext";
import { PHONE_DISPLAY, PHONE_TEL } from "../config";

export const Navigation = () => {
  const { open } = useContactForm();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [industriesOpen, setIndustriesOpen] = useState(false);
  const [industriesMobileOpen, setIndustriesMobileOpen] = useState(false);
  const handleTalkToExpert = (e) => {
    e.preventDefault();
    open({ intent: "contact", source: "Header" });
  };

  const navLinks = [
    { label: "Home", href: "/" },
    //{ label: "Our Kiosks", href: "#equipment" },
    { label: "Solutions", href: "/#solutions" },
    {
      label: "Industries We Serve",
      href: "#",
      hasDropdown: true,
      dropdownItems: [
        { label: "Car Wash", href: "/industries/car-wash" },
        { label: "Parking", href: "/industries/parking" },
      ],
    },

    
  ];

  const ctaButton = { label: "Talk to an Expert", href: "#footer" };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 80) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMenuOpen]);

  return (
    <>
      <header
        className={`bg-white shadow-sm fixed top-0 left-0 right-0 z-50 transition-transform duration-300 ${
          isVisible ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="max-w-screen-xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">

            {/* Logo */}
            <div className="flex-shrink-0">
              <a href="/">
                <img
                  src="/kinitas-logo.svg"
                  alt="Kinitas"
                  className="w-[174px] h-auto"
                />
              </a>
            </div>

            {/* Nav desktop */}
            <nav className="hidden lg:flex items-center gap-10">
              {navLinks.map((link) =>
                link.hasDropdown ? (
                  <div key={link.label} className="relative">
                    <button
                      className="flex items-center gap-1 text-[#1a1f6c] hover:text-[#2832c2] transition-colors duration-300 font-medium whitespace-nowrap"
                      onClick={() => setIndustriesOpen(!industriesOpen)}
                      onBlur={() => setTimeout(() => setIndustriesOpen(false), 150)}
                    >
                      {link.label}
                      <svg
                        className={`w-4 h-4 transition-transform duration-200 ${industriesOpen ? "rotate-180" : ""}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>

                    {industriesOpen && (
                      <div className="absolute top-full left-0 mt-2 w-44 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden z-50">
                        {link.dropdownItems.map((item) => (
                          <a
                            key={item.label}
                            href={item.href}
                            className="block px-4 py-3 text-[#1a1f6c] hover:bg-[#1a1f6c] hover:text-white transition-colors duration-200 font-medium text-sm"
                          >
                            {item.label}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <a
                    key={link.label}
                    href={link.href}
                    className="text-[#1a1f6c] hover:text-[#2832c2] transition-colors duration-300 font-medium whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                )
              )}
            </nav>

            {/* Botón CTA desktop */}
            <button
              onClick={handleTalkToExpert}
              className="hidden lg:inline-flex items-center justify-center bg-[#1a1f6c] text-white font-medium rounded-lg px-6 py-3 hover:bg-[#2832c2] transition-colors duration-300 whitespace-nowrap"
            >
              {ctaButton.label}
            </button>

            {/* Móvil: llamar con un toque + hamburger */}
            <div className="flex items-center gap-1 lg:hidden">
            <a
              href={PHONE_TEL}
              className="p-2 text-[#1a1f6c] rounded-lg hover:bg-gray-100"
              aria-label={`Call ${PHONE_DISPLAY}`}
            >
              <PhoneIcon className="w-6 h-6" />
            </a>
            <button
              type="button"
              className="p-2 text-[#1a1f6c] rounded-lg hover:bg-gray-100"
              onClick={() => setIsMenuOpen(true)}
              aria-label="Open menu"
              aria-expanded={isMenuOpen}
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            </div>
          </div>
        </div>
      </header>

      {/* Espaciador */}
      <div className="h-20" />

      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/50 z-40 transition-opacity duration-300 lg:hidden ${
          isMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={() => setIsMenuOpen(false)}
      />

      {/* Sidebar móvil */}
      <div
        className={`fixed top-0 right-0 h-full w-80 bg-gradient-to-b from-[#1a1f6c] to-[#0a0a23] z-50 shadow-2xl transition-transform duration-300 ease-in-out lg:hidden ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between p-6">
          <img
            src="/kinitas-logo.svg"
            alt="Kinitas"
            className="w-32 h-auto brightness-0 invert"
          />
          <button
            type="button"
            className="p-2 text-white/80 hover:text-white rounded-full hover:bg-white/10 transition-colors duration-300"
            onClick={() => setIsMenuOpen(false)}
            aria-label="Close menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <nav className="px-6 py-4">
          <ul className="flex flex-col space-y-1">
            {navLinks.map((link) => (
              <li key={link.label}>
                {link.hasDropdown ? (
                  <div>
                    <button
                      className="w-full flex items-center justify-between py-4 px-4 text-white/80 hover:text-white hover:bg-white/10 rounded-xl transition-all duration-300 font-medium text-lg border-b border-white/10"
                      onClick={() => setIndustriesMobileOpen(!industriesMobileOpen)}
                    >
                      {link.label}
                      <svg
                        className={`w-4 h-4 transition-transform duration-200 ${industriesMobileOpen ? "rotate-180" : ""}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {industriesMobileOpen && (
                      <div className="ml-4 mt-1 flex flex-col gap-1">
                        {link.dropdownItems.map((item) => (
                          <a
                            key={item.label}
                            href={item.href}
                            className="block py-3 px-4 text-white/70 hover:text-white hover:bg-white/10 rounded-lg transition-all duration-200 font-medium text-base"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            {item.label}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <a
                    href={link.href}
                    className="block py-4 px-4 text-white/80 hover:text-white hover:bg-white/10 rounded-xl transition-all duration-300 font-medium text-lg border-b border-white/10"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {link.label}
                  </a>
                )}
              </li>
            ))}
          </ul>

          <div className="mt-8 pt-8 border-t border-white/20">
            <button
              className="w-full inline-flex items-center justify-center bg-white text-[#1a1f6c] font-medium rounded-lg px-6 py-3 hover:bg-gray-100 transition-colors duration-300"
              onClick={(e) => { handleTalkToExpert(e); setIsMenuOpen(false); }}
            >
              {ctaButton.label}
            </button>
            <a
              href={PHONE_TEL}
              className="mt-3 w-full inline-flex items-center justify-center gap-2 border border-white/30 text-white font-medium rounded-lg px-6 py-3 hover:bg-white/10 transition-colors duration-300"
            >
              <PhoneIcon className="w-5 h-5" />
              Call {PHONE_DISPLAY}
            </a>
          </div>
        </nav>

        <div className="absolute bottom-8 left-6 right-6 text-white/40 text-sm text-center">
          © {new Date().getFullYear()} Kinitas USA, LLC
        </div>
      </div>

    </>
  );
};